import React, { useState, FC } from 'react';
import { Box, Text } from '@bechtel/gds';
import { map } from 'lodash';
import { BoxStyled, SkewedBoxStyledDark } from './styled';
import { SectionToggle } from '../section-toggle';
import { RodRequestFillerMaterial } from '@bechtel/types';

interface FillerMaterialProps {
  fillerMaterial: RodRequestFillerMaterial[];
}

export const FillerMaterial: FC<FillerMaterialProps> = ({ fillerMaterial }) => {
  const [isMaterialListOpen, setIsMaterialListOpen] = useState(true);

  return (
    <>
      <SectionToggle
        toggle={() => setIsMaterialListOpen(!isMaterialListOpen)}
        heading={'Filler Material Requests'}
        isOpen={isMaterialListOpen}
      />
      {isMaterialListOpen && (
        <Box
          flexDirection={{ sm: 'column' }}
          px={{ sm: '500' }}
          py={{ sm: '400' }}
          css={{ background: 'white' }}
          data-testid="filler-material-container"
        >
          {map(fillerMaterial, (item) => (
            <BoxStyled id={item.id}>
              <Box p={{ sm: '450' }} alignItems={{ sm: 'center' }}>
                <Text size="300">{item?.fillerMaterial.label}</Text>
              </Box>
              <Box alignItems={{ sm: 'center' }}>
                {map(item?.diameters, (diameter, idx: number) =>
                  idx % 2 === 0 ? (
                    <SkewedBoxStyledDark key={diameter?.id}>
                      <Text size="300" style={{ zIndex: 1, position: 'relative' }}>
                        {diameter?.label}
                      </Text>
                    </SkewedBoxStyledDark>
                  ) : (
                    <Box mr={{ sm: '200' }}>
                      <Text size="300" style={{ zIndex: 1, position: 'relative' }}>
                        {diameter?.label}
                      </Text>
                    </Box>
                  )
                )}
              </Box>
            </BoxStyled>
          ))}
        </Box>
      )}
    </>
  );
};
